export interface VideoItem {
  id: string;
  title: string;
  cover: string;
  description: string;
  category: string;
  tags: string[];
  publishedAt: string;
  views: number;
  likes: number;
  duration: string;
  author: string;
}

const AUTHOR = "糖心Tangxin";

export const videos: VideoItem[] = [
  {
    id: "v1",
    title: "清晨的一杯咖啡，与慢慢苏醒的城市",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20morning%20sunlight%20streaming%20through%20window%20onto%20a%20cup%20of%20latte%20on%20wooden%20table%20in%20cozy%20minimalist%20apartment%2C%20soft%20steam%2C%20calm%20lifestyle%20vlog%20aesthetic%2C%20warm%20orange%20tones%2C%20realistic%20photography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=450&seq=vlog-v1&orientation=landscape",
    description:
      "六点四十的城市还很安静，我给自己冲了一杯手冲咖啡。窗外第一班公交驶过，光一点点爬进房间。记录一个普通却踏实的清晨，希望也能让你慢下来。",
    category: "daily",
    tags: ["独居", "日常", "治愈"],
    publishedAt: "2026-09-28",
    views: 18420,
    likes: 1260,
    duration: "08:42",
    author: AUTHOR,
  },
  {
    id: "v2",
    title: "周末改造我的小阳台，一个人的绿意角落",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20urban%20balcony%20makeover%20with%20wooden%20flooring%2C%20hanging%20plants%20and%20string%20lights%2C%20folding%20chair%20and%20tiny%20table%2C%20warm%20afternoon%20light%2C%20cozy%20lifestyle%20aesthetic%2C%20warm%20tones%2C%20realistic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v2&orientation=landscape",
    description:
      "花了一整个周末，把堆杂物的小阳台变成能坐下来发呆的角落。铺木地板、挂上串灯、搬几盆绿植，过程有点累但超治愈。附上全部花费清单。",
    category: "daily",
    tags: ["家居", "改造", "日常"],
    publishedAt: "2026-09-21",
    views: 26310,
    likes: 2140,
    duration: "12:05",
    author: AUTHOR,
  },
  {
    id: "v3",
    title: "下班后的独居晚餐，一人食也要认真",
    cover:
      "https://readdy.ai/api/search-image?query=Simple%20home%20cooked%20dinner%20for%20one%20on%20a%20small%20kitchen%20counter%2C%20steaming%20noodles%20and%20vegetables%2C%20warm%20evening%20lamp%20light%2C%20cozy%20apartment%20kitchen%2C%20warm%20orange%20tones%2C%20realistic%20food%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v3&orientation=landscape",
    description:
      "加班到七点半，回家给自己煮了一碗番茄鸡蛋面。独居第 3 年，越来越懂得：好好吃饭，是对自己最基础的温柔。",
    category: "daily",
    tags: ["美食", "独居", "日常"],
    publishedAt: "2026-09-14",
    views: 15980,
    likes: 1180,
    duration: "09:18",
    author: AUTHOR,
  },
  {
    id: "v4",
    title: "整理房间的治愈两小时，把生活归位",
    cover:
      "https://readdy.ai/api/search-image?query=Tidy%20minimalist%20bedroom%20being%20organized%2C%20folded%20linen%20and%20neat%20shelves%2C%20baskets%20and%20books%2C%20soft%20daylight%2C%20warm%20neutral%20palette%2C%20calm%20declutter%20aesthetic%2C%20realistic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v4&orientation=landscape",
    description:
      "换季整理，丢掉一大袋不再需要的东西。整理房间其实是在整理心情，收拾完坐在床边喝口水的那一刻，整个人都松弛下来了。",
    category: "daily",
    tags: ["整理", "治愈", "日常"],
    publishedAt: "2026-09-07",
    views: 22150,
    likes: 1890,
    duration: "14:32",
    author: AUTHOR,
  },
  {
    id: "v5",
    title: "养了一只猫之后，我的生活变了",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20living%20room%20scene%20with%20a%20fluffy%20cat%20curled%20on%20a%20soft%20blanket%20near%20window%2C%20warm%20afternoon%20sunlight%2C%20plants%20and%20books%20around%2C%20warm%20tones%2C%20realistic%20pet%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v5&orientation=landscape",
    description:
      "从一只怕生的小猫，到现在每天在门口等我回家。养猫让我学会了对另一个生命负责，也让我没那么害怕独处了。这一天记录它满一岁。",
    category: "daily",
    tags: ["猫咪", "宠物", "治愈"],
    publishedAt: "2026-08-30",
    views: 41260,
    likes: 3520,
    duration: "11:47",
    author: AUTHOR,
  },
  {
    id: "v6",
    title: "菜市场里的烟火气，才是生活的底色",
    cover:
      "https://readdy.ai/api/search-image?query=Bustling%20outdoor%20vegetable%20market%20in%20early%20morning%2C%20fresh%20colorful%20produce%20in%20baskets%2C%20vendors%20and%20bicycles%2C%20warm%20morning%20light%2C%20authentic%20documentary%20aesthetic%2C%20warm%20tones%2C%20realistic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v6&orientation=landscape",
    description:
      "起了个大早去逛菜市场，跟卖菜阿姨讨价还价，提着一袋新鲜蔬菜回家。这里没有滤镜，却是我最喜欢的城市角落之一。",
    category: "daily",
    tags: ["城市", "美食", "日常"],
    publishedAt: "2026-08-23",
    views: 13740,
    likes: 960,
    duration: "10:26",
    author: AUTHOR,
  },
  {
    id: "v7",
    title: "一个人的雨天下午，听雨发呆也很快乐",
    cover:
      "https://readdy.ai/api/search-image?query=Rainy%20afternoon%20seen%20from%20inside%20a%20cozy%20room%2C%20raindrops%20on%20window%20glass%20with%20bokeh%2C%20a%20warm%20cup%20and%20a%20book%20on%20the%20sill%2C%20moody%20warm%20interior%20light%2C%20calm%20aesthetic%2C%20realistic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v7&orientation=landscape",
    description:
      "原本计划出门，结果下了一整天雨。干脆不出门了，泡杯茶、翻开没读完的书，听雨声发呆。有时候，允许自己什么都不做也是一种休息。",
    category: "daily",
    tags: ["治愈", "独居", "慢生活"],
    publishedAt: "2026-08-16",
    views: 17890,
    likes: 1520,
    duration: "07:55",
    author: AUTHOR,
  },
  {
    id: "v8",
    title: "记录普通的一天，平凡也值得被看见",
    cover:
      "https://readdy.ai/api/search-image?query=Everyday%20city%20life%20montage%20scene%2C%20person%20walking%20with%20coffee%20through%20quiet%20street%2C%20morning%20light%20and%20long%20shadows%2C%20warm%20natural%20tones%2C%20candid%20lifestyle%20aesthetic%2C%20realistic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v8&orientation=landscape",
    description:
      "没有特别事件的普通一天：起床、通勤、工作、买菜、睡觉。把它记录下来才发现，所谓生活，就是这些不起眼的重复里藏着的细节。",
    category: "daily",
    tags: ["日常", "生活记录", "治愈"],
    publishedAt: "2026-08-09",
    views: 12060,
    likes: 870,
    duration: "13:12",
    author: AUTHOR,
  },
  {
    id: "v9",
    title: "三天两夜海岛慢旅行，把节奏调慢一点",
    cover:
      "https://readdy.ai/api/search-image?query=Calm%20tropical%20island%20shore%20at%20soft%20sunset%2C%20clear%20turquoise%20water%20and%20gentle%20waves%2C%20wooden%20pier%2C%20warm%20golden%20sky%2C%20travel%20documentary%20aesthetic%2C%20realistic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v9&orientation=landscape",
    description:
      "临时订了张船票去海岛待了三天。没有密集打卡，就是看海、吃海鲜、睡到自然醒。有时候旅行不需要目的地，只需要换个地方慢下来。",
    category: "travel",
    tags: ["海岛", "慢旅行", "海景"],
    publishedAt: "2026-09-30",
    views: 38920,
    likes: 3210,
    duration: "18:24",
    author: AUTHOR,
  },
  {
    id: "v10",
    title: "京都秋日散步 Vlog，红叶与老街的味道",
    cover:
      "https://readdy.ai/api/search-image?query=Traditional%20Japanese%20old%20street%20in%20autumn%2C%20red%20maple%20leaves%20and%20wooden%20machiya%20houses%2C%20soft%20golden%20afternoon%20light%2C%20warm%20autumn%20palette%2C%20travel%20documentary%20aesthetic%2C%20realistic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v10&orientation=landscape",
    description:
      "十一月的京都，走在小巷里随处都是红叶。避开人潮的小路、转角的老茶铺、傍晚的鸭川。整理了这条不太一样的散步路线，附交通与时间安排。",
    category: "travel",
    tags: ["日本", "秋日", "散步"],
    publishedAt: "2026-09-23",
    views: 52130,
    likes: 4780,
    duration: "21:06",
    author: AUTHOR,
  },
  {
    id: "v11",
    title: "坐着绿皮火车去远方，慢一点也很好",
    cover:
      "https://readdy.ai/api/search-image?query=View%20from%20a%20train%20window%20of%20passing%20countryside%20fields%20and%20distant%20mountains%2C%20warm%20late%20afternoon%20light%2C%20nostalgic%20travel%20mood%2C%20warm%20tones%2C%20realistic%20photography%2C%20cinematic%20composition%2C%20high%20detail&width=800&height=450&seq=vlog-v11&orientation=landscape",
    description:
      "放弃了三个小时的高铁，选择坐一整夜的绿皮火车。窗外是不断后退的田野和村庄，邻座阿姨分了我一个橘子。这趟慢车，反而成了旅途里最好的部分。",
    category: "travel",
    tags: ["火车", "慢旅行", "沿途"],
    publishedAt: "2026-09-16",
    views: 29640,
    likes: 2360,
    duration: "16:38",
    author: AUTHOR,
  },
  {
    id: "v12",
    title: "沙漠露营的星空之夜，银河真的会说话",
    cover:
      "https://readdy.ai/api/search-image?query=Desert%20camp%20at%20night%20under%20a%20brilliant%20milky%20way%20sky%2C%20small%20tent%20with%20warm%20glow%2C%20sand%20dunes%20silhouette%2C%20deep%20blue%20night%20with%20warm%20campfire%20light%2C%20travel%20documentary%20aesthetic%2C%20realistic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v12&orientation=landscape",
    description:
      "第一次在沙漠里露营，晚上十一点躺在沙丘上看银河。风很大、沙子很冷，但抬头那一刻所有辛苦都值了。附上露营装备和观星时间建议。",
    category: "travel",
    tags: ["露营", "星空", "沙漠"],
    publishedAt: "2026-09-09",
    views: 34770,
    likes: 2940,
    duration: "19:52",
    author: AUTHOR,
  },
  {
    id: "v13",
    title: "雨季的清迈小城，安静得刚刚好",
    cover:
      "https://readdy.ai/api/search-image?query=Charming%20Southeast%20Asian%20old%20town%20street%20after%20rain%2C%20wet%20cobblestones%20reflecting%20warm%20lights%2C%20tropical%20plants%20and%20small%20cafes%2C%20lush%20green%20with%20warm%20accents%2C%20realistic%20travel%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v13&orientation=landscape",
    description:
      "淡季的清迈天天下雨，游客少了很多。躲在咖啡馆看雨、逛本地市集、和民宿老板聊天。原来淡季旅行，反而更能遇到这座城市真实的样子。",
    category: "travel",
    tags: ["泰国", "小城", "慢旅行"],
    publishedAt: "2026-09-02",
    views: 21480,
    likes: 1780,
    duration: "17:41",
    author: AUTHOR,
  },
  {
    id: "v14",
    title: "徒步山野看云海，累到腿软也值得",
    cover:
      "https://readdy.ai/api/search-image?query=Hiker%20on%20mountain%20ridge%20above%20a%20sea%20of%20clouds%20at%20sunrise%2C%20layered%20mountains%20in%20distance%2C%20warm%20golden%20light%20breaking%20through%20mist%2C%20epic%20landscape%2C%20realistic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v14&orientation=landscape",
    description:
      "凌晨三点出发爬了五个小时，就为了山顶这片云海。膝盖在抗议，但看到日出的瞬间眼泪差点掉下来。给想徒步的朋友整理了这条路线的难度和装备。",
    category: "travel",
    tags: ["徒步", "云海", "户外"],
    publishedAt: "2026-08-26",
    views: 31900,
    likes: 2680,
    duration: "20:15",
    author: AUTHOR,
  },
  {
    id: "v15",
    title: "海边小镇的慢生活，一天只做三件事",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20seaside%20fishing%20town%20with%20colorful%20boats%20in%20harbor%2C%20pastel%20houses%20along%20the%20water%2C%20soft%20morning%20light%2C%20calm%20coastal%20life%2C%20warm%20tones%2C%20realistic%20travel%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v15&orientation=landscape",
    description:
      "在一个没什么名气的小渔村住了一周。每天的日程只有三件事：看海、吃鱼、散步。住到第三天，终于把手机通知都关了。",
    category: "travel",
    tags: ["海边", "小镇", "慢生活"],
    publishedAt: "2026-08-19",
    views: 16240,
    likes: 1240,
    duration: "15:09",
    author: AUTHOR,
  },
  {
    id: "v16",
    title: "一场说走就走的公路旅行，没有攻略",
    cover:
      "https://readdy.ai/api/search-image?query=Open%20road%20trip%20through%20warm%20desert%20highway%20at%20sunset%2C%20car%20silhouette%20and%20long%20empty%20road%2C%20dramatic%20orange%20sky%2C%20freedom%20and%20adventure%20mood%2C%20realistic%20cinematic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v16&orientation=landscape",
    description:
      "周四下午突然想出去走走，加了油就出发了。没有攻略、没有订酒店，走到哪儿算哪儿。这大概是我今年做过最冲动也最不后悔的决定。",
    category: "travel",
    tags: ["公路旅行", "自驾", "自由"],
    publishedAt: "2026-08-12",
    views: 28370,
    likes: 2310,
    duration: "22:30",
    author: AUTHOR,
  },
  {
    id: "v17",
    title: "关于独处的十件小事，我慢慢喜欢上一个人",
    cover:
      "https://readdy.ai/api/search-image?query=Person%20sitting%20alone%20by%20a%20large%20window%20with%20a%20notebook%20and%20coffee%2C%20soft%20warm%20afternoon%20light%2C%20quiet%20reflective%20mood%2C%20minimal%20cozy%20interior%2C%20warm%20tones%2C%20realistic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v17&orientation=landscape",
    description:
      "独处不等于孤独。这期视频分享我这些年学会的十件小事：一个人吃饭、看电影、搬家、过节。如果你也常一个人，希望这条能陪你一会儿。",
    category: "insight",
    tags: ["独处", "成长", "思考"],
    publishedAt: "2026-10-01",
    views: 45310,
    likes: 4120,
    duration: "13:58",
    author: AUTHOR,
  },
  {
    id: "v18",
    title: "我如何对抗拖延症，试了三年才有效的方法",
    cover:
      "https://readdy.ai/api/search-image?query=Desk%20with%20a%20weekly%20planner%2C%20sticky%20notes%20and%20a%20checklist%2C%20warm%20lamp%20light%20in%20the%20evening%2C%20organized%20workspace%2C%20focus%20and%20productivity%20mood%2C%20warm%20tones%2C%20realistic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v18&orientation=landscape",
    description:
      "作为一个资深拖延患者，我试过番茄钟、待办清单、打卡 App，大多没用。这期讲三个真正帮到我的笨办法，以及为什么它们对我有效。",
    category: "insight",
    tags: ["拖延", "效率", "方法"],
    publishedAt: "2026-09-24",
    views: 36780,
    likes: 3290,
    duration: "12:24",
    author: AUTHOR,
  },
  {
    id: "v19",
    title: "二十几岁该不该焦虑？我的真实答案",
    cover:
      "https://readdy.ai/api/search-image?query=Thoughtful%20young%20person%20looking%20out%20of%20a%20city%20window%20at%20dusk%2C%20warm%20city%20lights%20below%2C%20reflective%20quiet%20mood%2C%20warm%20amber%20tones%2C%20realistic%20portrait%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v19&orientation=landscape",
    description:
      "身边朋友陆续买房、升职、结婚，我却还在原地打转。这期聊了聊关于年龄焦虑的心里话：承认焦虑，但别让它替你做决定。",
    category: "insight",
    tags: ["焦虑", "成长", "思考"],
    publishedAt: "2026-09-17",
    views: 39870,
    likes: 3560,
    duration: "14:47",
    author: AUTHOR,
  },
  {
    id: "v20",
    title: "极简生活一年后，我的变化有多大",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20minimalist%20room%20with%20few%20objects%2C%20wooden%20floor%2C%20single%20chair%20and%20plant%2C%20soft%20natural%20light%2C%20calm%20uncluttered%20aesthetic%2C%20warm%20neutral%20palette%2C%20realistic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v20&orientation=landscape",
    description:
      "从买买买到一年只添置必需品，我想说说极简带给我的真实变化：不只是房间变空了，钱包、时间和内心也一起变轻了。",
    category: "insight",
    tags: ["极简", "生活", "成长"],
    publishedAt: "2026-09-10",
    views: 27540,
    likes: 2380,
    duration: "11:36",
    author: AUTHOR,
  },
  {
    id: "v21",
    title: "如何找到自己的节奏，不被别人带着跑",
    cover:
      "https://readdy.ai/api/search-image?query=Person%20jogging%20alone%20on%20a%20quiet%20tree-lined%20path%20in%20early%20morning%2C%20soft%20golden%20light%20through%20leaves%2C%20calm%20focused%20mood%2C%20warm%20tones%2C%20realistic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v21&orientation=landscape",
    description:
      "刷到别人的生活总会慌，后来我慢慢学会分清：哪些是我真正想要的，哪些只是被人群推着走。分享三个帮我找回节奏的小练习。",
    category: "insight",
    tags: ["节奏", "内耗", "方法"],
    publishedAt: "2026-09-03",
    views: 23790,
    likes: 2010,
    duration: "12:58",
    author: AUTHOR,
  },
  {
    id: "v22",
    title: "关于坚持的一点点思考，第 100 期特辑",
    cover:
      "https://readdy.ai/api/search-image?query=Stack%20of%20journals%20and%20a%20camera%20on%20a%20wooden%20desk%20by%20a%20window%2C%20warm%20afternoon%20light%2C%20gentle%20reflective%20mood%2C%20cozy%20creative%20workspace%2C%20warm%20tones%2C%20realistic%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v22&orientation=landscape",
    description:
      "不知不觉做到了第 100 期。回头看最早那些画质糟糕的视频，居然有点想哭。这期不聊方法论，就聊聊坚持这件小事本身。",
    category: "insight",
    tags: ["坚持", "记录", "成长"],
    publishedAt: "2026-08-27",
    views: 31560,
    likes: 3470,
    duration: "16:20",
    author: AUTHOR,
  },
  {
    id: "v23",
    title: "慢下来真的会落后吗？我的答案有点反常识",
    cover:
      "https://readdy.ai/api/search-image?query=Person%20enjoying%20a%20slow%20cup%20of%20tea%20on%20a%20quiet%20balcony%20at%20golden%20hour%2C%20soft%20warm%20light%2C%20relaxed%20mindful%20mood%2C%20plants%20around%2C%20warm%20tones%2C%20realistic%20lifestyle%20photography%2C%20high%20detail&width=800&height=450&seq=vlog-v23&orientation=landscape",
    description:
      "所有人都在卷，我却试着慢了一点点。这期说说慢下来之后发生的事：效率没降，反而更清楚了。也许节奏比速度更重要。",
    category: "insight",
    tags: ["慢生活", "思考", "内耗"],
    publishedAt: "2026-08-20",
    views: 20180,
    likes: 1690,
    duration: "10:48",
    author: AUTHOR,
  },
  {
    id: "v24",
    title: "记录的意义，为什么我想一直拍下去",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20video%20camera%20and%20printed%20photos%20scattered%20on%20a%20warm%20wooden%20table%2C%20soft%20window%20light%2C%20nostalgic%20reflective%20mood%2C%20cozy%20tones%2C%20realistic%20photography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=450&seq=vlog-v24&orientation=landscape",
    description:
      "常有人问我：发这些视频有什么用？这期我想认真回答一次。记录不是为了被看见，而是为了在很多年后，还能想起当时的自己。",
    category: "insight",
    tags: ["记录", "意义", "成长"],
    publishedAt: "2026-08-13",
    views: 18920,
    likes: 1720,
    duration: "13:34",
    author: AUTHOR,
  },
];

export const heroVideos = ["v9", "v10", "v5", "v17"];